import assetClassificationActions from "../../../actions/assetClassificationActions";
import assetClassificationTableColumns, {
  assetClassificationTableLeftFixedColumns,
} from "./assetClassificationTableColumns";
import generateEntityTable from "../../../hocs/generateEntityTable";

const AssetClassificationsTable = generateEntityTable({
  entityPluralString: "assetClassifications",
  entityActions: assetClassificationActions,
  editorRoutePath: "/asset-classification-edition",
  columns: assetClassificationTableColumns,
  leftFixedColumns: assetClassificationTableLeftFixedColumns,
  operations: [],
});

export default AssetClassificationsTable;
